import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import { userRanks } from 'config';
// our components
import { Query } from 'components/common/Query';
import Filter from './Filter';

/**
 * Query to fetch categories from api
 */
export const CATEGORIES_QUERY = gql`
  query {
    categories {
      id
      title
      subcategories {
        id
        title
      }
    }
  }
`;

/**
 * Query to fetch provinces from api
 */
export const PROVINCES_QUERY = gql`
  query {
    provinces {
      id
      name
      municipalities {
        id
        name
      }
    }
  }
`;

/**
 * Query to fetch users from api
 */
export const ADMIN_USERS_QUERY = gql`
  query adminUsers($rank: [FilterRank]!) {
    adminUsers(rank: $rank) {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class AdFilterContainer extends Component {
  constructor(props) {
    super(props);
    this.Compose = adopt({
      queryCategories: this.listCategories,
      queryProvinces: this.listProvinces,
      queryAdminUsers: this.listAdminUsers,
    });
  }

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listCategories = ({ render }) => (
    <Query query={CATEGORIES_QUERY} variables={{}} notifyOnNetworkStatusChange>
      {({ data, loading }) =>
        render({ categoriesData: data, loadingCategories: loading })
      }
    </Query>
  );

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listProvinces = ({ render }) => (
    <Query query={PROVINCES_QUERY} variables={{}} notifyOnNetworkStatusChange>
      {({ data, loading }) =>
        render({ provincesData: data, loadingProvinces: loading })
      }
    </Query>
  );

  /**
   * @description
   * Query callback to compose.
   *
   * @param {*} render - Query's render props.
   * @returns {*} - Query component.
   */
  listAdminUsers = ({ render }) => (
    <Query
      query={ADMIN_USERS_QUERY}
      variables={{ rank: [userRanks.STAFF, userRanks.ADMIN] }}
      notifyOnNetworkStatusChange
    >
      {({ data, loading }) =>
        render({ adminUsersData: data, loadingAdminUsers: loading })
      }
    </Query>
  );

  /**
   * @description
   * Render Filter component.
   * @returns {*} - Filter component.
   */
  render() {
    const {
      showFilters,
      showCollapseFilters,
      filter,
      appliedFilter,
      restartFilters,
    } = this.props;
    return (
      <this.Compose>
        {({
          queryCategories: { categoriesData, loadingCategories },
          queryProvinces: { provincesData, loadingProvinces },
          queryAdminUsers: { adminUsersData, loadingAdminUsers },
        }) => {
          if (loadingCategories || loadingAdminUsers || loadingProvinces)
            return (
              <ContentLoader
                height={50}
                width={960}
                speed={2}
                primaryColor="#f3f3f3"
                secondaryColor="#e1e0e2"
              >
                <rect x="16" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="156" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="16" y="30" rx="3" ry="3" width="90" height="10" />
                <rect x="116" y="30" rx="3" ry="3" width="60" height="10" />
                <rect x="186" y="30" rx="3" ry="3" width="60" height="10" />
                <rect x="296" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="435" y="10" rx="3" ry="3" width="130" height="10" />
                <rect x="254" y="30" rx="3" ry="3" width="60" height="10" />
              </ContentLoader>
            );
          return (
            <Filter
              appliedFilter={appliedFilter}
              categories={categoriesData ? categoriesData.categories : []}
              provinces={provincesData ? provincesData.provinces : []}
              users={adminUsersData ? adminUsersData.adminUsers : { edges: [] }}
              filter={filter}
              showFilters={showFilters}
              showCollapseFilters={showCollapseFilters}
              restartFilters={restartFilters}
            />
          );
        }}
      </this.Compose>
    );
  }
}

/**
 * AdFilterContainer PropTypes
 * @param appliedFilter - prop pass to Filter
 * @param showCollapseFilters - prop pass to Filter
 * @callback filter - prop pass to Filter
 * @callback showFilters - prop pass to Filter
 * @callback restartFilters - prop pass to Filter
 */

AdFilterContainer.propTypes = {
  appliedFilter: PropTypes.shape({}).isRequired,
  showCollapseFilters: PropTypes.bool.isRequired,
  filter: PropTypes.func.isRequired,
  showFilters: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
};

export default AdFilterContainer;
